import { combineReducers } from "redux";

import helper from "./helper";
import * as actions from "./actions";
import * as thunks from "./asyncThunk";
import reducers from "./reducer";

export default {
  actions: {
    ...helper.actions,
    ...actions,
    ...thunks,
  },
  reducer: combineReducers({
    asyncReducers: helper.reducer,
    static: reducers,
  }),
};
